import clsx from 'clsx'

import Icon from './Icon'
import {usePopups} from '~/services/popup'

import type {PopupData} from '~/services/popup'

type PopupProps = Pick<PopupData, 'message' | 'type' | 'close'> & {multiline: boolean}

function Popup({message, type, multiline, close}: PopupProps) {
    return (
        <div
            className={`popup popup_${type}`}
            role='alert'
            aria-live='assertive'
        >
            <div className='popup__body grid grid_rg-2'>
                <div
                    className={clsx(
                        'popup__message',
                        multiline && 'popup__message_multiline',
                    )}
                >
                    {message}
                </div>
            </div>
            <button
                type='button'
                className='popup__close'
                onClick={close}
            >
                <Icon name='clear'/>
            </button>
        </div>
    )
}

export default function Popups() {
    const [popups] = usePopups()

    if (!popups.length)
        return null

    return (
        <div className='popups'>
            {popups.map(({id, message, type, multiline, close}) =>
                <Popup
                    multiline={multiline}
                    key={id}
                    message={message}
                    type={type}
                    close={close}
                />,
            )}
        </div>
    )
}
